import {ReactElement, useEffect, useState} from "react";
import FrameOneModal from "./modalComponents/FrameOneModal";
import FrameModalBody from "./modalComponents/FrameModalBody";
import classNames from "classnames";
import FrameButton from "../buttons/FrameButton";
import confetti from "canvas-confetti";
import {FaFacebook, FaLinkedinIn, FaMailBulk, FaTwitter} from "react-icons/fa";
import {EmailShareButton, LinkedinShareButton, TwitterShareButton} from "@ciaran0/react-share";
import GoVipLevelUpAnimation from "../GoVipLevelUpAnimation";
import {IoCloseSharp} from "react-icons/io5";
import Toast from "@/components/Toast";
import useThemePreference from "@/hooks/useThemePreference";
import { FacebookShareModal } from "../FacebookShareModal";

interface Props {
    isOpen: boolean;
    toggle: () => void;
    level: number;
    dpayGained: number;
}

function GoVipLevelUpModal(props: Props): ReactElement {
    const [
        headerVisible,
        setHeaderVisible,
    ] = useState<boolean>(false);

    const [
        showLootboxMintFailedToast,
        setShowLootboxMintFailedToast,
    ] = useState<boolean>(false);
    const [isFacebookShareModalOpen, setIsFacebookShareModalOpen] = useState(false);
    const animationTimeout: number = 500;
    const titleMessage: string = "I leveled up my GoVIP on DevourPlay!";
    const shareMessage: string = `I reached GoVIP level ${props.level} on DevourPlay and earned $${props.dpayGained}.00 ${import.meta.env.VITE_TOKEN_NAME}!\nTry it out with me here!`;
    const shareURL: string = "https://devourplay.io/go-vip-dashboard"; // import.meta.env.VITE_WEB_URL
    const {isOnDarkMode} = useThemePreference();

    useEffect(() => {
        if (props.isOpen && !headerVisible) {
            setTimeout(() => {
                setHeaderVisible(true);
            }, animationTimeout);
        } else if (!props.isOpen && headerVisible) {
            setHeaderVisible(false);
        }
        if (props.isOpen && headerVisible) {
            [
                0.25,
                0.5,
                0.75,
            ].forEach(x => {
                confetti({
                    particleCount: 150,
                    startVelocity: 35,
                    angle: 90,
                    gravity: 0.2,
                    spread: 360,
                    ticks: 800,
                    origin: {
                        x: x,
                        y: -0.5,
                    },
                    zIndex: 50,
                });
            });
        }
    }, [
        props.isOpen,
        headerVisible,
    ]);

    function handleToastDismissal(): void {
        setShowLootboxMintFailedToast(false);
    }

    return (
        <>
            <Toast
                message="Sorry, the minting process for your lootbox NFT has failed. Please try again in an hour."
                variant="error"
                isOpen={showLootboxMintFailedToast}
                showButton={false}
                onDismiss={handleToastDismissal}
                duration={3000}
            />
            <FacebookShareModal quote={shareMessage}
                link={shareURL}
                isVisible={isFacebookShareModalOpen}
                onClose={() => setIsFacebookShareModalOpen(false)}
                hashtag={"#DevourPlay"} />
            <FrameOneModal
                isOpen={props.isOpen}
                toggle={props.toggle}
                contentClassName="go-vip-level-up-modal"
            >
                <div className="go-vip-level-up-modal_close govip-nft-redeem-confirm-modal_body_close-wrapper">
                    <IoCloseSharp onClick={props.toggle}/>
                </div>
                <FrameModalBody className="go-vip-level-up-modal_body">

                    {!isOnDarkMode &&
                        <div className="go-vip-level-up-modal_level-up-animation">
                            <GoVipLevelUpAnimation level={props.level}/>
                        </div>
                    }
                    <div
                        className={classNames("go-vip-level-up-modal_header-con", {
                            "go-vip-level-up-modal_header-con_visible": headerVisible,
                        })}
                    >
                        <h3>
                            You've reached level {props.level}!
                        </h3>
                    </div>

                    <div
                        className={classNames("go-vip-level-up-modal_content-con", {
                            "go-vip-level-up-modal_content-con_visible": headerVisible,
                        })}
                    >
                        <p className={"go-vip-level-up-modal_small-text-con"}>
                            You earned
                        </p>
                    </div>

                    <div
                        className={classNames(
                            "go-vip-level-up-modal_content-con",
                            "go-vip-level-up-modal_dpay-info-con",
                            "go-vip-level-up-modal_display-row", {
                                "go-vip-level-up-modal_content-con_visible": headerVisible,
                            },
                        )}
                    >
                        <div className="go-vip-level-up-modal_display-row">
                            <img
                                className={"go-vip-level-up-modal_dpay-icon-con"}
                                src={`${import.meta.env.VITE_CDN_URL}/images/token-white.webp`}
                                alt={"dpay icon"}
                            />
                            <h5 className="go-vip-level-up-modal_dpay-text-con">
                                {import.meta.env.VITE_TOKEN_NAME}
                            </h5>
                        </div>
                        <div className="go-vip-level-up-modal_dpay-info-con_amount">+
                            ${props.dpayGained}.00
                        </div>
                    </div>

                    <div
                        className={classNames("go-vip-level-up-modal_content-con", {
                            "go-vip-level-up-modal_content-con_visible": headerVisible,
                        })}
                    >
                        <p className={"go-vip-level-up-modal_small-text-con"}>
                            Check your email for a bigger level up reward!
                        </p>
                    </div>

                    <div
                        className={classNames("go-vip-level-up-modal_cta-con", {
                            "go-vip-level-up-modal_cta-con_visible": headerVisible,
                        })}
                    >
                        <FrameButton
                            color="purple"
                            size="normal"
                            onClick={props.toggle}
                        >
                            Continue
                        </FrameButton>
                    </div>

                    <div className="go-vip-level-up-modal_footer">
                        <div className="go-vip-level-up-modal_footer_text">Share on social media</div>

                        <div className="go-vip-level-up-modal_footer_socials">
                            <TwitterShareButton
                                title={shareMessage}
                                url={shareURL}
                                hashtags={[
                                    "DevourPlay",
                                    "GoVip",
                                    "GoFrens",
                                ]}
                                className="go-vip-level-up-modal_bottom-socials-btn"
                                style={{
                                    backgroundColor: "none",
                                }}
                            >
                                <FaTwitter/>
                            </TwitterShareButton>

                            <div
                                onClick={() => setIsFacebookShareModalOpen(true)}
                                className="go-vip-level-up-modal_bottom-socials-btn"
                                style={{
                                    backgroundColor: "none",
                                    cursor: "pointer",
                                }}
                            >
                                <FaFacebook/>
                            </div>

                            <LinkedinShareButton
                                url={shareURL}
                                title={titleMessage}
                                summary={shareMessage}
                                source={shareURL}
                                className="go-vip-level-up-modal_bottom-socials-btn"
                                style={{
                                    backgroundColor: "none",
                                }}
                            >
                                <FaLinkedinIn/>
                            </LinkedinShareButton>

                            <EmailShareButton
                                url={shareURL}
                                subject={titleMessage}
                                body={shareMessage}
                                className="go-vip-level-up-modal_bottom-socials-btn"
                                style={{
                                    backgroundColor: "none",
                                }}
                            >
                                <FaMailBulk/>
                            </EmailShareButton>
                        </div>
                    </div>
                </FrameModalBody>
            </FrameOneModal>
        </>
    );
}

export default GoVipLevelUpModal;
